import { TInviteRequest } from '@gen2/api/invite-requests/api';
import { ReactNode } from 'react';
import { create } from 'zustand';
import { RequestGroup } from './shared-drawer';
import { SortableRequestItemProps } from './sortable-request-list/sortable-request-item';
import { RequestListType } from './sortable-request-list/sortable-request-list';

export type DrawerConfig = {
    title?: string;
    content?: ReactNode;
    contentProps?: {
        type?: RequestListType;
        items?: SortableRequestItemProps[] | TInviteRequest[];
        itemsToGroup?: RequestGroup[];
        inviteId?: string;
        followUpId?: string;
        templateId?: string;
    };
};

type SharedDrawerStore = {
    isOpen: boolean;
    config: DrawerConfig;
    setIsOpen: (isOpen: boolean) => void;
    setConfig: (config: DrawerConfig) => void;
    reset: () => void;
};

const initialState = {
    isOpen: false,
    config: {},
};

export const useSharedDrawerStore = create<SharedDrawerStore>((set) => ({
    ...initialState,
    setIsOpen: (isOpen: boolean) => set({ isOpen }),
    setConfig: (config: DrawerConfig) => set({ config }),
    reset: () => set(initialState),
}));